
import { ExtraFieldsTextInputType, ExtraFieldTextConfig } from "@/models/dossier-configs/extra-field-text-config";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
import AppExtraFieldTextOptionsMetaDataAutocomplete from "./ExtraFieldTextOptionsMetaDataAutocomplete.vue";
import AppExtraFieldTextOptionsMetaDataSelect from "./ExtraFieldTextOptionsMetaDataSelect.vue";
import AppExtraFieldBaseOptions from "./ExtraFieldBaseOptions.vue";
import { ExtraFieldsType } from "@/utils/models/extra-fields";

export default Vue.extend({
	data(){
		return {
			config: new ExtraFieldTextConfig()
		};
	},
	props: {
		value: {
			type: Object as ()=>ExtraFieldTextConfig,
			required: true
		},
		optionsIndex: {
			type: Number,
			required: true
		},
		extraFieldsType: {
			type: String as ()=>ExtraFieldsType,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			return this.$ct("extra-field-text-options", {index: this.optionsIndex});
		},
		inputTypeMetaData():ISelectItem<ExtraFieldsTextInputType>[]{
			return Object.keys(ExtraFieldsTextInputType).map((k,i)=>{
				return {
					text: this.$ct(`extra-fields-input-types.${k}`),
					value: Object.values(ExtraFieldsTextInputType)[i]
				};
			});
		},
		isAutocompleteSelected():boolean {
			return this.config.InputType == ExtraFieldsTextInputType.AUTOCOMPLETE;
		},
		contactGroupIds():number[]{
			if (this.config.InputType == ExtraFieldsTextInputType.ALL_CONTACTS_AUTOCOMPLETE){
				return [1,2,3];
			}else if (this.config.InputType == ExtraFieldsTextInputType.CLIENT_AUTOCOMPLETE){
				return [1];
			}else if (this.config.InputType == ExtraFieldsTextInputType.SUPPLIER_AUTOCOMPLETE) {
				return [2];
			}else if (this.config.InputType == ExtraFieldsTextInputType.PROSPECT_AUTOCOMPLETE) {
				return [3];
			}
			return [];
		},
		isContactAutocomplete():boolean {
			return this.contactGroupIds.length > 0;
		},
		isSelect():boolean {
			return this.config.InputType == ExtraFieldsTextInputType.SELECT;
		},
		supportsTab():boolean {
			return [
				ExtraFieldsType.CONTACT,
				ExtraFieldsType.PRODUCT,
				ExtraFieldsType.PURCHASE,
				ExtraFieldsType.CRM,
				ExtraFieldsType.PROJECT,
				ExtraFieldsType.CAR
			].indexOf(this.extraFieldsType) != -1 && this.config.InputType == ExtraFieldsTextInputType.DEFAULT;
		},
		isMultiSelect():boolean {
			return this.config.InputType == ExtraFieldsTextInputType.MULTI_SELECT;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.config = new ExtraFieldTextConfig(this.value);
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.config);
			this.close();
		}
	},
	components: {
		AppExtraFieldTextOptionsMetaDataAutocomplete,
		AppExtraFieldTextOptionsMetaDataSelect,
		AppExtraFieldBaseOptions
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
